import type { ReactNode } from "react";
import { createContext, useContext, useState } from "react";

type DeepLinkContextType = {
  isDeepLinkHandled: boolean;
  handleDeepLink: (callback?: () => void) => void;
}

// Create the context with default values
const DeepLinkContext = createContext<DeepLinkContextType | undefined>(undefined);

const DeepLinkProvider = ({ children }: { children: ReactNode }) => {
  const [isDeepLinkHandled, setIsDeepLinkHandled] = useState(false);

  function handleDeepLink(callback?: () => void) {
    setIsDeepLinkHandled(true);
    callback?.();
  }

  return <DeepLinkContext value={{ isDeepLinkHandled, handleDeepLink }}>{children}</DeepLinkContext>;
};

function useDeepLinkContext() {
  const context = useContext(DeepLinkContext);
  if (context === undefined) {
    throw new Error("useDeepLinkContext must be used within a DeepLinkProvider");
  }
  return context;
}

export {  DeepLinkProvider, useDeepLinkContext };
